import { translate } from '../i18n';

export type RhinoMessageDescriptor = {
  key: string;
  params: Record<string, unknown>;
};

// The exporter resolves the complete message through Rails for each locale.
// Resolve at parse time so a mounted form uses the currently selected language.
export const rhinoResolveMessage = (
  descriptor: RhinoMessageDescriptor,
  fallback: string
): string => translate(descriptor.key, { defaultValue: fallback });
